import {ItemService} from '.';
import type {ILineItem, ILineItemOption} from '..';

class Text {
	//
	//
	// ItemView STRINGS
	//

	instructMinMaxChoices(lineItem: ILineItem, optionId: ILineItemOption['optionId']) {
		const minMax = ItemService.lineItemMinMaxStatusForOption(lineItem, optionId);

		if(minMax === null) {
			console.error('No min/max choice set found for optionId (text)', optionId);
			return '';
		}

		if(minMax.count < minMax.min) {
			const remaining = minMax.min - minMax.count;
			return `${remaining} more "${minMax.name}" ${remaining === 1 ? 'is' : 'are'} required`;
		}
		if(minMax.count >= minMax.max) {
			return `You cannot select more than ${minMax.max} "${minMax.name}"`;
		}

		// Don't show anything if they are between min and max
		return '';
	}
}

export const TextService = new Text();
